import { COLORS } from '../../../utils/Application_Constants';

export const HIERARCHY_BORDER_STYLE = `1.5px dashed ${COLORS.LT_MIDNIGHT25}`;
export const TABLE_CELL_TYPOGRAPHY_STYLES = {
    color: COLORS.LT_MIDNIGHT75,
    fontSize: 14,
    fontWeight: 400,
    lineHeight: 'normal',
};

export const TABLE_CELL_TYPOGRAPHY_STYLES_INVOICED = {
    ...TABLE_CELL_TYPOGRAPHY_STYLES,
    color: COLORS.LT_MIDNIGHT,
};

export const MIN_COLUMN_WIDTH = 120;

export const FOCUSED_CHECKBOX_STYLE = {
    backgroundColor: 'rgba(25, 118, 210, 0.05)',
    boxShadow: 'inset 0 0 0 1px rgba(25, 118, 210, 0.2)',
};
